/* PDP Media Gallery: Mehr-anzeigen-Button (Modern-Pattern)

   Wenn die Galerie mehr als 6 Bilder enthaelt, werden die ueberzaehligen
   versteckt und ein "Mehr anzeigen"-Button unter dem Grid eingefuegt.
   Click toggled zwischen collapsed (nur 6) und expanded (alle).

   Re-runs bei `shopify:section:load`, damit Theme-Editor-Reloads das
   Layout nicht zerschiessen. Idempotent via dataset-Flag.
*/
(function () {
  var LIMIT = 6;
  var TEXT_MORE = 'Mehr anzeigen';
  var TEXT_LESS = 'Weniger anzeigen';

  function chevronSvg() {
    return (
      '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" ' +
      'xmlns="http://www.w3.org/2000/svg" aria-hidden="true" ' +
      'class="gallery-show-more__icon">' +
      '<path d="M4 6L8 10L12 6" stroke="currentColor" stroke-width="1.5" ' +
      'stroke-linecap="round" stroke-linejoin="round"/></svg>'
    );
  }

  function setupGallery(scope) {
    var root = scope || document;
    var lists = root.querySelectorAll('.product__media-list');
    lists.forEach(function (list) {
      if (list.dataset.showMoreSetup === 'true') return;

      var items = Array.prototype.slice.call(
        list.querySelectorAll('li.product__media-item')
      );
      if (items.length <= LIMIT) return;

      list.dataset.showMoreSetup = 'true';
      list.classList.add('show-more-collapsed');

      items.slice(LIMIT).forEach(function (item) {
        item.classList.add('show-more-hidden');
      });

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'gallery-show-more';
      btn.innerHTML =
        '<span class="gallery-show-more__text">' + TEXT_MORE + '</span>' +
        chevronSvg();

      // Btn in einen Wrapper packen, der unter der Liste sitzt — saubere
      // Trennung von Dawn's Grid-Layout
      var wrapper = document.createElement('div');
      wrapper.className = 'gallery-show-more-wrapper';
      wrapper.appendChild(btn);

      list.parentNode.insertBefore(wrapper, list.nextSibling);

      btn.addEventListener('click', function () {
        var expanded = list.classList.toggle('show-more-expanded');
        list.classList.toggle('show-more-collapsed', !expanded);
        btn.classList.toggle('is-expanded', expanded);
        btn.querySelector('.gallery-show-more__text').textContent = expanded
          ? TEXT_LESS
          : TEXT_MORE;
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setupGallery();
    });
  } else {
    setupGallery();
  }
  document.addEventListener('shopify:section:load', function (event) {
    setupGallery(event.target);
  });
})();
